import { skipToken, useQuery } from '@tanstack/react-query';

import { isDefined } from '../../../utils/is';
import { loadOrderQuery } from '../../selectionRepository';

export const ORDER_QUERY_KEY = 'order';

interface Props {
  refetchOnMount?: boolean;
  orderId: Nullable<string> | undefined;
}

export const useOrderDetails = ({ orderId, refetchOnMount }: Props) => {
  const isEnabled = isDefined(orderId);

  return useQuery({
    enabled: isEnabled,
    queryFn: isEnabled ? async () => loadOrderQuery(orderId) : skipToken,
    queryKey: [ORDER_QUERY_KEY, orderId],
    refetchOnMount,
    retry: false,
  });
};
